const validate = values => {
  const errors = {}

  if (!values.name) {
    errors.name = "The place name is required!"
  }

  if (!values.latitude) {
    errors.latitude = "The place latitude is required!"
  }

  if (!values.longitude) {
    errors.longitude = "The place longitude  is required!"
  }

  if (!values.city) {
    errors.city = "The place city is required!"
  }

  if (!values.state) {
    errors.state = "The place state is required!"
  }

  return errors
}

export default validate
